<template>
  <div class="contact-form">
    <template v-if="message">
      <div class="contact-form__success">
        <span
          class="contact-form__message"
          :class="`contact-form__message--type_success`"
        >
          {{ message }}
        </span>
      </div>
    </template>
    <template v-else>
      <div>
        <loader
          class="contact-form__loader"
          v-if="showLoader"
        />
        <Form
          v-show="!showLoader"
          :id="id"
          class="contact-form__form"
          :action="action"
          @submit="onSubmit"
          :initial-values="model"
        >
          <ErrorMessage
            name="global"
            v-slot="{ message }"
          >
            <general-message
              v-html="message"
              :autoclose="false"
              type="warning"
            />
          </ErrorMessage>

          <csrf-input
            ref="csrf"
          />

          <div class="form__group form__group--row">
            <div class="form__col-5">
              <input-vee4
                name="firstname"
                rules="required|min:2|max:50"
                :label="$t('global.firstname.label')"
              />
            </div>
            <div class="form__col-7">
              <input-vee4
                name="lastname"
                rules="required|min:2|max:50"
                :label="$t('global.lastname.label')"
              />
            </div>
          </div>

          <!--companyName-->
          <div class="form__group">
            <input-vee4
              name="companyName"
              rules="min:0|max:50"
              :label="$t('global.companyName.label')"
            />
          </div>

          <!--email-->
          <div class="form__group">
            <input-vee4
              name="email"
              type="email"
              rules="required|email|min:5|max:100"
              :label="$t('global.email.label')"
            />
          </div>

          <!--phone-->
          <div class="form__group">
            <input-vee4
              name="phone"
              type="tel"
              rules="max:25"
              :label="$t('global.phone.label')"
            />
          </div>

          <!--subject-->
          <div class="form__group">
            <select-vee4
              name="subject"
              :options="subjects"
              :initial-value="model.subject"
              :label="$t('contact.subject')"
              rules="required"
            />
          </div>

          <!--content-->
          <div class="form__group">
            <text-area-vee4
              name="content"
              rules="required"
              :label="$t('contact.content')"
            />
          </div>

          <div class="form__group agb">
            <checkbox-vee4
              name="tos"
              :label="$t('global.tosAndPrivacy.label')"
              rules="required"
            />
          </div>

          <div class="contact-form__submit-container">
            <button
              type="submit"
              name="contact-form-button"
              class="contact-form__submit-button | button button--alt"
            >
              {{ $t('global.submit.button') }}
            </button>
            <re-captcha
              v-if="captchaActive"
              v-model="recaptchaResponse"
              ref="captcha"
              inline
              action="contact_us"
              @token="saveCaptchaToken"
            />
          </div>
        </Form>
      </div>
    </template>
  </div>
</template>

<script>
  import Loader from '../loader/loader.vue';
  import CsrfInput from '../csrfInput/csrfInput.vue';
  import ReCaptcha from '../reCaptcha/reCaptcha.vue';
  import GeneralMessage from '../generalMessage/generalMessage.vue';
  import pigeon from '../../utilities/js/pigeon/pigeon.js';
  import FormMixin from '../../utilities/vueMixins/formMixin/formMixin';
  import globalStateComputedMixin from "../../utilities/vueMixins/globalStateComputedMixin/globalStateComputedMixin";
  import { ErrorMessage, Form } from "vee-validate";
  import InputVee4 from "../inputVue/inputVee4.vue";
  import CheckboxVee4 from "../checkbox/checkboxVee4.vue";
  import SelectVee4 from "../select/selectVee4.vue";
  import TextAreaVee4 from "../textarea/textAreaVee4.vue";

  export default {
    components: {
      TextAreaVee4,
      SelectVee4,
      CheckboxVee4,
      InputVee4,
      ErrorMessage,
      Form,
      Loader,
      CsrfInput,
      ReCaptcha,
      GeneralMessage,
    },
    mixins: [
      FormMixin,
      globalStateComputedMixin,
    ],
    props: {
      firstname: String,
      lastname: String,
      companyName: String,
      subject: {
        type: String,
        default: ''
      },
      content: {
        type: String,
        default: ''
      },
      email: String,
      phone: String,
    },
    data() {
      return {
        model: {
          companyName: this.companyName ? this.companyName : '',
          firstname: this.firstname ? this.firstname : '',
          lastname: this.lastname ? this.lastname : '',
          phone: this.phone ? this.phone : '',
          email: this.email ? this.email : '',
          subject: this.subject ? this.subject : this.$t('contact.subject.order.value'),
          content: this.content,
          tos: false,
        },
        captchaToken: '',
        recaptchaResponse: '',
        message: '',
        showLoader: false,
        subjects: [
          { label: this.$t('contact.subject.order.name'), value: this.$t('contact.subject.order.value') },
          { label: this.$t('contact.subject.account.name'), value: this.$t('contact.subject.account.value') },
          { label: this.$t('contact.subject.products.name'), value: this.$t('contact.subject.products.value') },
          { label: this.$t('contact.subject.payment.name'), value: this.$t('contact.subject.payment.value') },
          { label: this.$t('contact.subject.other.name'), value: this.$t('contact.subject.other.value') },
        ],
      };
    },
    mounted() {
      pigeon.subscribe('formsubmit:success', this.handleFormSubmit.bind(this));
      pigeon.subscribe('formsubmit:error', () => this.showLoader = false);
    },
    methods: {
      saveCaptchaToken(token) {
        this.captchaToken = token;
      },
      onSubmit(values, actions) {
        this.showLoader = true;
        if (this.captchaActive) {
          this.$refs.captcha.execute().then(() => {
            this.model['recaptchaResponse'] = this.recaptchaResponse
            this.model['captchaToken'] = this.captchaToken
            this.submitAjaxFormVee4(values, (errors) => {
              errors.forEach(fieldError => {
                actions.setFieldError(fieldError.field, fieldError.msg)
              })
            });
          });
        } else {
          this.submitAjaxFormVee4(values, (errors) => {
            errors.forEach(fieldError => {
              actions.setFieldError(fieldError.field, fieldError.msg)
            })
          });
        }
      },
      handleFormSubmit(id) {
        if (id === this.id) {
          this.message = this.$t('contact.success');
        }
      },
    }
  };

</script>
